import { AppName, UnsubscribeReason } from 'root-constants'

export const OPTION_VALUES = {
  YES: 'yes',
  NO: 'no',
}

export const DEFAULT_DISCOUNT_PERCENTAGE = 35

export const PERSONALIZED_DISCOUNT_REASONS = [
  UnsubscribeReason.TOO_EXPENSIVE,
  UnsubscribeReason.DID_NOT_GET_WHAT_EXPECTED,
  UnsubscribeReason.NO_RESULTS,
]

export const APPS_WITHOUT_VAT_INFO_TEXT: string[] = [
  AppName.SPILIO,
  AppName.DEEPLY,
  AppName.AYAHPATH,
]
